var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['parallax-element', 'wow', 'fadeInUp', _vm.uniqueClass],attrs:{"data-parallax":"block","data-wow-duration":_vm.speed,"data-speed":_vm.speed}},[_c('img',{attrs:{"src":_vm.icon,"alt":("parallax-icon_" + _vm.icon)}})])}
var staticRenderFns = []

export { render, staticRenderFns }